import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTextareaDrag: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"textarea-drag"} maskId="square-filled-radius-0-stroke-1-IconTextareaDrag"><path d="M22.1035 6.60352L6.60352 22.1035L5.89648 21.3965L21.3965 5.89648L22.1035 6.60352ZM21.75 14.2354L22.1035 14.5879L14.6035 22.1035L13.8965 21.3965L21.3965 13.8818L21.75 14.2354Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTextareaDrag;
